import { render, staticRenderFns } from "./AfricanRumble.vue?vue&type=template&id=4ae77fb0&"
import script from "./AfricanRumble.vue?vue&type=script&lang=js&"
export * from "./AfricanRumble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports